// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".provider-countries[data-v-68401b32]{display:flex;align-items:center;color:#646a70;padding:0 8px;max-width:200px;margin-right:16px;white-space:nowrap;height:100%;border-radius:4px;border:1px solid #eaedef;background-color:#fff}", ""]);
// Exports
module.exports = exports;
